import * as React from 'react';
import StepbarRoot from '../../../../BaseComponents/Stepbar/index';
import { useSelector } from 'react-redux';
import { getOrder } from '../../../store/order/selectors';
import Cart from '../../../../Cart/Cart';
import { Drawer } from '@mui/material';
import { useTheme } from '../../../../theme';
import { useCart } from './hooks';
import SimpleLoader from '../../../../SimpleLoader';
import { OrderStatus } from '@websky/graphql';
import StepbarPayload from './StepbarPayload/StepbarPayload';
import ErrorBoundary from '../../../../ErrorBoundary/ErrorBoundary';
import { useCartPrices } from '../../../../Cart/hooks';
import { useRenderers } from '../../../../renderProps';
const Stepbar = ({ activeStepIndex, activeStep, steps, alwaysShowSteps, alwaysShowStepsOnOrderCancelled = true, hideFlightPrice, renderAdditionalStep }) => {
    var _a;
    const [isOpenCart, setOpenCart] = React.useState(false);
    const order = useSelector(getOrder);
    const cartPrices = useCartPrices();
    const openCart = () => setOpenCart(true);
    const closeCart = () => setOpenCart(false);
    const theme = useTheme('Checkout').Stepbar;
    const { onDeleteItem, loading } = useCart();
    const { CheckoutDesktopStepbar: CheckoutDesktopStepbarOverride = StepbarRoot } = useRenderers();
    const showCart = order.status !== OrderStatus.Cancelled;
    const showSteps = alwaysShowSteps ||
        order.status === OrderStatus.New ||
        order.status === OrderStatus.Booked ||
        (order.status === OrderStatus.Cancelled && alwaysShowStepsOnOrderCancelled);
    const availableSteps = React.useMemo(() => {
        return Object.values(steps !== null && steps !== void 0 ? steps : {}).filter(step => !step.isHidden);
    }, [steps, activeStepIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckoutDesktopStepbarOverride, { activeStep: activeStep, totalPrice: order.priceToPay.total, steps: showSteps ? steps : {}, onCartClick: showCart && openCart, renderAdditionalStep: renderAdditionalStep, additional: React.createElement(StepbarPayload, { orderStatus: order.status, canAddServices: order.canAddServices, exchangeAvailable: (_a = order.exareInfo) === null || _a === void 0 ? void 0 : _a.exchangeAvailability }) }),
        showCart && (React.createElement(ErrorBoundary, { renderFallback: () => null },
            React.createElement(Drawer, { classes: { paper: theme.paper }, anchor: "right", open: isOpenCart, onClose: closeCart },
                loading && React.createElement(SimpleLoader, null),
                React.createElement(Cart, { activeStep: activeStepIndex, steps: availableSteps, flight: order.flight, travellers: order.travellers, customer: order.customer, services: order.additionalServices, prices: cartPrices, hideFlightPrice: hideFlightPrice, onClose: closeCart, onServiceDelete: onDeleteItem, showPassengers: order.status !== OrderStatus.New }))))));
};
export default Stepbar;
